import _map from 'lodash/map';
import { cleanFilesForApi } from '../../helpers';

export function createCustomFieldsArray(formValues = {}) {
  return _map(formValues, (v, k) => {
    const { fileId } = v || {};

    return {
      companyCustomFieldId: k,
      value: fileId || v
    };
  });
}

export function formatCustomFieldsForApiCall(userData = {}, formValues = {}) {
  const requiredData = {
    ...userData,
    memberCustomValues: createCustomFieldsArray(formValues)
  };

  return cleanFilesForApi(requiredData);
}



/** WEBPACK FOOTER **
 ** ./src/actions/customFields/helpers.js
 **/